/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopRequest,
  TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopModel,
  IMappers,
  TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse,
  TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../../entities/schemas/ErrorResponseSchema';

export function createChatsBulkOperationsMoveAllFromSectionToArchiveDesktopModel(
  parameters: TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopRequest,
): TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/chats/bulk-operations/move-all-from-section-to-archive-desktop/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopRequest;
}

export async function fetchChatsBulkOperationsMoveAllFromSectionToArchiveDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsBulkOperationsMoveAllFromSectionToArchiveDesktopModel(parameters),
    config,
  )) as FetchResponse<TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse>;
}
